import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from '../rootReducer'

export type SetSRPFloatingAIChatEnabledPayload =
    | boolean
    | { enabled: boolean; enableOnboardingPopUp?: boolean }

interface AIFeatureState {
    srpFloatingAIChatEnabled: boolean
    srpFloatingAIChatOnboardingOpen: boolean
}

const initialState: AIFeatureState = {
    srpFloatingAIChatEnabled: false,
    srpFloatingAIChatOnboardingOpen: false
}

const aiFeatureSlice = createSlice({
    name: 'aiFeature',
    initialState,
    reducers: {
        setSRPFloatingAIChatEnabled: (state, action: PayloadAction<SetSRPFloatingAIChatEnabledPayload>) => {
            const enabled =
                typeof action.payload === 'boolean' ? action.payload : action.payload.enabled
            const enableOnboardingPopUp =
                typeof action.payload === 'boolean'
                    ? false
                    : Boolean(action.payload.enableOnboardingPopUp)
            state.srpFloatingAIChatEnabled = enabled
            // Do not tie onboarding to "enabled": opening the Drawer on the same commit as
            // mounting SRPFloatingAIChat can trigger React "update on not yet mounted" warnings
            // with MUI Modal. Only force-close onboarding when the feature is turned off.
            if (!enabled) {
                state.srpFloatingAIChatOnboardingOpen = false
            }
            if (enableOnboardingPopUp) {
                state.srpFloatingAIChatOnboardingOpen = true
            }
        },
        setSRPFloatingAIChatOnboardingOpen: (state, action: PayloadAction<boolean>) => {
            state.srpFloatingAIChatOnboardingOpen = action.payload
        },
        closeSRPFloatingAIChatOnboarding: state => {
            state.srpFloatingAIChatOnboardingOpen = false
        }
    }
})

export const {
    setSRPFloatingAIChatEnabled,
    setSRPFloatingAIChatOnboardingOpen,
    closeSRPFloatingAIChatOnboarding
} = aiFeatureSlice.actions

export const selectSRPFloatingAIChatEnabled = (state: RootState) => state.aiFeature.srpFloatingAIChatEnabled
export const selectSRPFloatingAIChatOnboardingOpen = (state: RootState) => state.aiFeature.srpFloatingAIChatOnboardingOpen

export default aiFeatureSlice.reducer
